//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "successOperate",
  data() {
    return {
      loginUrl: "/portal/login", //登录页面
      showInfo: "You are successfully signed up",
      input: "",
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
          disabled: true,
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      value: "",
    };
  },
  methods: {
    loginPage() {
      this.$router.push({
        path: this.loginUrl,
        query: {},
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/tempElement.vue